<template>
  <div class="box">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-12 col-12">
          <div class="row">
            <div class="mt-3 col-lg-12 col-xs-12 center">
              <img src="/images/LOGO_JOVOOL.png" width="120px" />
            </div>
          </div>
          <transition name="fade" mode="out-in" appear>
            <sweetalert-icon
              v-if="!questionsStep && !step_final && candidate"
              icon="loading"
              style="background-color: white; width: 100%; margin-top: 20px; display: flex; justify-content: center"
            />
            <SignIn
              :account_uid="account_uid"
              v-if="signInStep && !candidate"
              :job="job"
              :job_link="job_link"
              :candidate_uid="candidate_uid"
              :selective_process_uid="selective_process_uid"
              :onlySignin="true"
              :custom_header="true"
              :avoid_tag="true"
            >
              <div class="mt-5">
                <h2 class="color-primary label-bold">AVALIAÇÃO</h2>
                <h5 class="color-primary mt-4">
                  PREPARE-SE PARA RESPONDER ALGUMAS PERGUNTAS.
                </h5>

                <h5 class="color-primary mt-4">
                  FAÇA SEU LOGIN E BOA SORTE!
                </h5>
              </div>
            </SignIn>
            <div
              v-if="questionsStep"
            >
              <Evaluations
                v-if="evaluations && evaluations.length > 0"
                :evaluations="evaluations"
                :account_uid="account_uid"
                class="mt-2"
              />
              <Questions
                v-else
                class="mt-2"
                :account_uid="account_uid"
                :job_questions="questions"
                :selective_process_uid="selective_process_uid"
              />
            </div>


            <div
              class="card card-body mt-2 text-dark bg-white"
              v-if="step_bigfive"
              style="height: 100%; overflow: scroll; overflow-x: hidden"
            >
              <Bigfive
                :bigfive_uid="bigfive.uid"
                :candidate_uid="candidate_uid"
                :amount_itens="bigfive.amount_itens"
                :account_uid="account_uid"
              />
            </div>
            <Congratulation
              v-if="step_final"
              :job="job"
              class="mt-3"
              :show="false"
              label="PROVA REALIZADA COM SUCESSO!"
            />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SignIn from "@/Candidates/SignIn/New.vue";
import Questions from "@/Jobs/Questions.vue";
import Congratulation from "@/Jobs/Congratulation.vue";
import Evaluations from "@/Candidates/Applies/Evaluations.vue";
import Bigfive from "@/Bigfives/Test.vue";

export default {
  props: [
    "questions",
    "account_uid",
    "candidate_uid",
    "job",
    "job_link",
    "selective_process_uid",
    "bigfive",
    "evaluations",
    "candidate"
  ],
  components: { Questions, SignIn, Congratulation, Bigfive, Evaluations },
  data: () => ({
    signInStep: true,
    questionsStep: false,
    step_final: false,
    step_bigfive: false,
    candidateUid: "",
  }),
  mounted() {
    document.body.classList.add("body_sign_up");
    if (this.candidate_uid) {
      this.disableSteps();
      this.questionsStep = true;
    }

    eventBus.$on("goToQuestions", (candidate) => {
      if (!this.candidate) location.reload();
      this.disableSteps();
      this.questionsStep = true;
      this.candidateUid = candidate ? candidate.uid : undefined;
    });

    eventBus.$on("finalScreen", () => {
      this.disableSteps();
      this.sendReport();
      if (this.bigfive) {
        this.step_bigfive = true;
        return;
      }

      this.step_final = true;
    });

    eventBus.$on("gotoFinal", (_) => {
      this.disableSteps();
      this.step_final = true;
    });
  },
  methods: {
    disableSteps() {
      this.signInStep = false;
      this.questionsStep = false;
      this.step_bigfive = false;
      this.step_final = false;
    },
    sendReport() {
      let selected_questions = {
        selective_process_uid: this.selective_process_uid,
        job_uid: this.job.uid,
        candidate_uid: this.candidate_uid || this.candidateUid,
      };

      axios.post("/selected_questions/recruiter", { selected_questions });
    },
  },
};
</script>
